import { stripServingStyleSuffix } from './stripServingStyleSuffix';

/**
 * Identity key for beer names. Matches backend normalizeBeerNameKey:
 * serving-style suffix strip (ITT-946), NFKC, lowercase, non-letter/digit runs
 * become spaces.
 *
 * @param {string|null|undefined} name - Display or proposed beer name
 * @returns {string|null} Collapsed identity key, or null when unusable
 */
export function beerNameIdentityKey(name) {
  if (!name || typeof name !== 'string') {
    return null;
  }
  const stripped = stripServingStyleSuffix(name);
  const folded = stripped
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()
    .replace(/\s+/g, ' ');
  return folded.length > 0 ? folded : null;
}
